import { _ } from 'wgnet-awesomejs';
import $ from 'jquery';
import URI from 'urijs';

import BaseComponent from 'source/lib/base_component';
import Settings from 'source/lib/settings_model';
import messages from 'messages';

import template from './template.html';

const ErrorMessageBlock = BaseComponent.extend({
    name: 'error-message-block',
    template,
    initialize(...args) {
        BaseComponent.prototype.initialize.apply(this, args);

        this.data.mode = this.data.mode || 'basic';

        this.initializeErrors(this.data.mode);
        this.errorEventsBind();
    },
    initializeErrors(mode) {
        this.errorMessages = _.extract(messages, `errors.${mode}`, {});

        if (mode === 'external-registration') {
            this.errorExtra = {
                invalid_external_parameters: _.bind(this.handleRegistrationFailedError, this),
                spa_conflicted_login: _.bind(this.handleRegistrationFailedError, this),
                spa_conflicted_uid: _.bind(this.handleRegistrationFailedError, this),
                authentication_failed: _.bind(this.handleRegistrationAuthFailedError, this)
            };
        }
    },
    errorEventsBind() {
        this.$root = $('#js-view');
        // TODO: Separate events for common, basic and external errors
        this.$root.on('component:all:error', _.bind(this.onParentError, this));
        this.$root.on('component:all:error:clear', _.bind(this.onClearErrors, this));
    },
    onParentError(event, result, child, options) {
        const response = result.responseJSON;
        const errors = _.extract(response, 'errors');
        const extras = _.extract(response, 'extras');
        const nonFieldErrors = errors ? errors.__all__ : [];
        const data = child.data;
        let toRender;

        if (response) {
            if (nonFieldErrors && nonFieldErrors.length > 0) {
                toRender = nonFieldErrors;
            } else if (!errors) {
                toRender = ['server_timeout_answer'];
            }
        } else {
            toRender = ['server_not_answer'];
        }

        if (!toRender) {
            return;
        }

        this.handleErrors(toRender, extras, data, options);
        this.render();
    },
    onClearErrors() {
        this.$('.js-form-errors-block').hide();
    },

    handleErrors(errors, extras, data, options = {}) {
        const error = errors[0];
        let message = this.errorMessages[error];

        if (!message) {
            this.data.hasError = false;
            return;
        }

        if (this.errorExtra && _.has(this.errorExtra, error)) {
            message = this.errorExtra[error](message, extras, data);
        } else if (_.isFunction(message)) {
            const { service } = options;
            const externalName = Settings.get(`Authentication.ExternalProvidersNames.${service}`, '');
            message = message({ externalName });
        }
        this.data.messages = [message];
        this.data.hasError = true;
    },
    handleRegistrationFailedError(message, extras) {
        const templateParameters = this.getSigninParameters(extras);

        return _.template(message)({
            url: templateParameters.url.toString()
        });
    },

    getSigninParameters(data) {
        const url = new URI(Settings.get('Authentication.LoginUrl', ''));
        const urlParams = {
            next: data.next_url
        };

        url.addQuery(urlParams);

        return { url };
    },
    handleRegistrationAuthFailedError(message, extras, data) {
        if (_.isString(message)) {
            return message;
        }
        const providerKey = data['external-provider'];
        const providerName = Settings.get(`Authentication.ExternalProvidersNames.${providerKey}`);
        const templateParameters = {
            name: data['external-name'],
            providerName,
            url: `${Settings.get('Authentication.LoginUrl')}?external=${providerKey}`
        };
        return message(templateParameters);
    }
});

export default ErrorMessageBlock;



// WEBPACK FOOTER //
// ./static-source/js/lib/component/block/error_message/index.js